import Filesystem from 'components/Filesystem'

export interface Props {
  rootPath: string
  ignore?: string[]
}

function Filetree({
  rootPath,
  ignore,
}: Props) {
  return (
    <Filesystem
      ignore={ignore}
      rootPath={rootPath}
    />
  )
}

export default Filetree
